// extracted by mini-css-extract-plugin
module.exports = {"image":"ZQ","loaded":"_Q","placeholder":"aR"};